<template>
    <div :class="{ 'calendar-disabled-wrapper': disable }">
        <VueDatePicker
            ref="datePicker"
            input-class="hidden"
            :hide-navigation="hideExtraLayouts"
            :close-on-auto-apply="false"
            :disabled-dates="disabledDates"
            :highlight="highlightDisabledDate == true ? disabledDates : []"
            :highlight-disabled-days="highlightDisabledDate"
            :min-date="minDate"
            :modelValue="dateValue"
            :menu-class-name="menuClass"
            :auto-apply="showTimeFormate ? false : !range"
            :max-date="maxDate"
            :range="range"
            :format="range === true ? 'MMM dd, yyyy' : ''"
            :partial-range="false"
            :position="position ? position : 'center'"
            :auto-position="autoposition"
            :hide-input-icon="hideCalenderIcon"
            :hide-clear-button="hideClearButton"
            :clearable="clearable && !disable"
            :action-row="{ showPreview: false }"
            @click-outside="onCLickOutSideOrCansal"
            @update:modelValue="handleDate"
            :teleport="teleport"
            :disabled-week-days="props.daysWeekDisable"
            :is-24="timeFormate"
            :placeholder="$t('errorPage.select_a_date')"
            :disabled="disable"
        >
            <!-- Custom Month/Year Header -->
            <template
                #month-year="{ month, year, months, handleMonthYearChange, updateMonthYear }"
                v-if="useCustomTrigger"
            >
                <div class="dp-controller">
                    <div class="dp-month-year">
                        <div class="dp-month">
                            <span class="dp-month-text">{{ months[month].text }}</span>
                        </div>
                        <div class="dp-month">
                            <span class="dp-month-text">{{ year }}</span>
                        </div>
                    </div>

                    <div class="dp-rightsection">
                        <button
                            type="button"
                            class="dp-today-btn"
                            @click="goToToday(updateMonthYear)"
                            :disabled="disable"
                        >
                            <span class="dp-today-label">Today</span>
                        </button>

                        <div class="dp-btn-group">
                            <button
                                type="button"
                                class="dp-icon-btn"
                                @click="!disable ? handleMonthYearChange(false) : ''"
                                title="Previous Month"
                                :disabled="disable"
                            >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>

                            <button
                                type="button"
                                class="dp-icon-btn"
                                @click="!disable ? handleMonthYearChange(true) : ''"
                                title="Next Month"
                                :disabled="disable"
                            >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </template>

            <template #clear-icon="{ clear }" v-if="clearable && !disable">
                <img :src="closeIcon" @click="clear">
            </template>

            <template #left-sidebar v-if="range === true && !disable">
                <ul class="WrapperPresetRange">
                    <li @click="weekCall(0)" class="cursor-pointer" :class="isActive == 0 ? 'isActive' : ''">
                        {{ $t('general.current_week') }}
                    </li>
                    <li @click="monthCall(1)" class="cursor-pointer" :class="isActive == 1 ? 'isActive' : ''">
                        {{ $t('general.current_month') }}
                    </li>
                </ul>
            </template>

            <template #action-buttons v-if="range === true && !disable">
                <p class="btn btn-cansal cursor-pointer" @click="onCLickOutSideOrCansal">{{ $t('Projects.cancel') }}</p>
                <p class="btn btn-success cursor-pointer" @click="onSubmitVal">{{ $t('general.apply') }}</p>
            </template>

            <template #action-extra="slotProps" v-if="$slots['action-extra'] && !disable">
                <slot name="action-extra" v-bind="slotProps"></slot>
            </template>

            <template #trigger v-if="range === false">
                <div
                    v-if="useCustomTrigger"
                    class="custom-date-input"
                    :class="{ 'disabled-trigger': disable }"
                >
                    <div class="date-display">
                        <svg class="calendar-icon" width="16" height="16" viewBox="0 0 16 16" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect x="1.5" y="2.5" width="13" height="12" rx="1.5" stroke="currentColor"
                                stroke-width="1" />
                            <path d="M1.5 6H14.5" stroke="currentColor" stroke-width="1" />
                            <path d="M5 1V4" stroke="currentColor" stroke-width="1" stroke-linecap="round" />
                            <path d="M11 1V4" stroke="currentColor" stroke-width="1" stroke-linecap="round" />
                        </svg>

                        <span class="date-text">
                            {{ dateValue ? convertDateFormat(dateValue, props.format ? props.format : '', {
                                showDayName: false
                            }) : (props.format ? props.format : settingDateFormat) }}
                        </span>
                    </div>

                    <div class="nav-arrows">
                        <button
                            type="button"
                            class="nav-btn"
                            @click.stop="goToPrevDay"
                            :disabled="disable"
                        >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                        <button
                            type="button"
                            class="nav-btn"
                            @click.stop="goToNextDay"
                            :disabled="disable"
                        >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>

                <!-- ORIGINAL TRIGGER -->
                <template v-else>
                    <div
                        v-if="!isShowDateAndicon"
                        class="d-flex"
                        :class="{ 'disabled-trigger': disable }"
                    >
                        <span
                            :title="convertDateFormat(dateValue, props.format ? props.format : '', { showDayName: false })"
                            v-if="dateValue != ''"
                            class="due_date-listing"
                            :class="disable ? 'disabled-cursor' : 'cursor-pointer'"
                            :style="[
                                {
                                    color: displayColor || ((typeof dateValue == 'string'
                                        ? new Date(dateValue).getTime() < new Date().setHours(0, 0, 0, 0)
                                        : dateValue < new Date().setHours(0, 0, 0, 0)) && overdue ? 'red' : 'black')
                                }
                            ]"
                        >
                            {{ convertDateFormat(dateValue, props.format ? props.format : '', { showDayName: false }) }}
                        </span>

                        <img
                            v-else
                            :src="isWithoutBorderImage ? withoutBorderImageIcon : dateImage"
                            :class="disable ? 'disabled-cursor' : 'cursor-pointer'"
                            alt="dateImage"
                        >
                    </div>

                    <div
                        v-if="isShowDateAndicon"
                        :class="{ 'disabled-trigger': disable }"
                    >
                        <div v-if="!showTimeFormate">
                            <input
                                v-if="dateValue != ''"
                                readonly
                                class="date_format_cal font-roboto-sans"
                                :class="[
                                    { 'calendar-comp': !calenderImage, 'calendar-comp-white': calenderImage },
                                    disable ? 'disabled-cursor' : ''
                                ]"
                                type="text"
                                :placeholder="convertDateFormat(dateValue, props.format ? props.format : '', { showDayName: false })"
                                :id="inputId"
                            >
                            <input
                                v-else
                                class="date_format_cal font-roboto-sans"
                                readonly
                                type="text"
                                :class="[
                                    { 'calendar-comp': !calenderImage, 'calendar-comp-white': calenderImage },
                                    disable ? 'disabled-cursor' : ''
                                ]"
                                :placeholder="props.format ? props.format : settingDateFormat"
                                :id="inputId"
                            >
                        </div>

                        <div v-else>
                            <input
                                v-if="dateValue != ''"
                                readonly
                                class="date_format_cal font-roboto-sans"
                                :class="[
                                    {
                                        'bg-transparent border-0 cursor-pointer': !calenderImage && !disable,
                                        'calendar-comp-white': calenderImage,
                                        'text-ellipse': isEllipsis,
                                        'd-block': isEllipsis,
                                        'mw-150px': isEllipsis,
                                        'date_mw': isTask
                                    },
                                    disable ? 'disabled-cursor' : ''
                                ]"
                                type="text"
                                :placeholder="convertDateAndTime(timeFormate, dateValue, props.format)"
                                :id="inputId"
                            >
                            <input
                                v-else
                                class="date_format_cal font-roboto-sans"
                                readonly
                                type="text"
                                :class="[
                                    {
                                        'bg-transparent border-0 cursor-pointer': !calenderImage && !disable,
                                        'calendar-comp-white': calenderImage,
                                        'text-ellipse': isEllipsis,
                                        'd-block': isEllipsis,
                                        'mw-150px': isEllipsis,
                                        'date_mw': isTask
                                    },
                                    disable ? 'disabled-cursor' : ''
                                ]"
                                :placeholder="`${props.format} , ${timeFormate ? '24 Hour' : 'AM/PM'}`"
                                :id="inputId"
                            >
                        </div>
                    </div>
                </template>
            </template>
        </VueDatePicker>
    </div>
</template>

<script setup>
import { defineComponent, defineProps, ref, defineEmits, onMounted, watch, nextTick } from 'vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import { useToast } from 'vue-toast-notification';
import '@vuepic/vue-datepicker/dist/main.css';
import { useConvertDate } from '@/composable/index';
import { useStore } from "vuex";
const { getters } = useStore();
import moment from 'moment';
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const { convertDateFormat } = useConvertDate();

defineComponent({
    components: { VueDatePicker }
})

const $toast = useToast();
const settingDateFormat = ref(getters['settings/companyDateFormat'].dateFormat);
const emit = defineEmits(['update:modelValue', 'outsideClick', 'handleSubmit']);
const closeIcon = require("@/assets/images/svg/CloseSidebar.svg");

const props = defineProps({
    hideExtraLayouts: {
        type: Array,
        default: () => ['time', 'minutes', 'hours', 'seconds']
    },
    modelValue: {
        default: () => new Date().toLocaleString()
    },
    disabledDates: {
        type: [Array, Function],
        default: () => []
    },
    highlightDisabledDate: {
        type: Boolean,
        default: false
    },
    minDate: {
        type: [Date, String],
        default: ''
    },
    maxDate: {
        type: [Date, String],
        default: ''
    },
    isShowDateAndicon: {
        type: Boolean,
        default: false
    },
    menuClass: {
        type: String,
        default: ''
    },
    teleport: {
        type: Boolean,
        default: true
    },
    range: {
        type: Boolean,
        default: false
    },
    position: {
        type: String,
        default: ''
    },
    autoposition: {
        type: Boolean,
        default: true
    },
    hideClearButton: {
        type: Boolean,
        default: false
    },
    hideCalenderIcon: {
        type: Boolean,
        default: false
    },
    calenderImage: {
        type: Boolean,
        default: false
    },
    inputId: {
        type: String,
        default: 'inputId'
    },
    overdue: {
        type: Boolean,
        default: false
    },
    format: {
        type: String,
        default: ''
    },
    daysWeekDisable: {
        type: [Array],
        default: () => []
    },
    timeFormate: {
        type: Boolean,
        default: false
    },
    showTimeFormate: {
        type: Boolean,
        default: false
    },
    clearable: {
        type: Boolean,
        default: false
    },
    isEllipsis: {
        type: Boolean,
        default: false
    },
    isTask: {
        type: Boolean,
        default: false
    },
    preSelectable: {
        type: Boolean,
        default: true
    },
    preSelectType: {
        type: String,
        default: "month"
    },
    isWithoutBorderImage: {
        type: Boolean,
        default: false
    },
    useCustomTrigger: {
        type: Boolean,
        default: false
    },
    disable: {
        type: Boolean,
        default: false
    },
    displayColor: {
        type: String,
        default: ''
    }
})

const dateValue = ref(props.modelValue);
const prevaldate = ref(null);
const datePicker = ref('');
const dateImage = require('@/assets/images/svg/date_cion.svg');
const withoutBorderImageIcon = require('@/assets/images/svg/compoment_inactive_icons/comp_calender_inactive.svg');

watch(() => props.modelValue, (newval, oldVal) => {
    if (newval != null && newval != '' && newval != oldVal) {
        dateValue.value = newval;
    } else {
        if (newval == '') {
            dateValue.value = '';
        }
    }
})

//Define Methods
const handleDate = (modelData) => {
    if (props.disable) return;

    if (props.range === true) {
        if (modelData.includes(null) || modelData[0] == null || modelData[1] == null) {
            $toast.error(t('Toast.Please_select_start_end_date'), { position: 'top-right' });
            return;
        }
    }

    if (props.showTimeFormate) {
        dateValue.value = modelData;
        datePicker.value.closeMenu();
        emit('update:modelValue', modelData);
    } else {
        if (new Date(modelData).toLocaleDateString() == new Date(dateValue.value).toLocaleDateString() && props.range == false) {
            return;
        }
        dateValue.value = modelData;
        datePicker.value.closeMenu();
        emit('update:modelValue', modelData);
    }

    emit('handleSubmit')
}

const goToToday = (updateMonthYear) => {
    if (props.disable) return;
    const today = new Date();
    updateMonthYear(today.getMonth(), today.getFullYear());
}

const goToPrevDay = () => {
    if (props.disable || !dateValue.value) return;

    const currentDate = new Date(dateValue.value);
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() - 1);

    if (props.minDate && newDate < new Date(props.minDate)) return;

    dateValue.value = newDate;
    emit('update:modelValue', newDate);
    emit('handleSubmit');
}

const goToNextDay = () => {
    if (props.disable || !dateValue.value) return;

    const currentDate = new Date(dateValue.value);
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + 1);

    if (props.maxDate && newDate > new Date(props.maxDate)) return;

    dateValue.value = newDate;
    emit('update:modelValue', newDate);
    emit('handleSubmit');
}

const isActive = ref(0);

function startOfWeek(date) {
    const dayOfWeek = date.getDay();
    const diff = date.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
    return new Date(date.getFullYear(), date.getMonth(), diff);
}

function endOfWeek(date) {
    const start = startOfWeek(date);
    const end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6);
    return end;
}

function startOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}

function endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

function weekCall(value, preSelect = false) {
    if (props.disable) return;

    isActive.value = value;
    const date1 = startOfWeek(new Date());
    const date2 = endOfWeek(new Date());
    dateValue.value = [date1, date2];
    prevaldate.value = dateValue.value;
    if (preSelect) emit('update:modelValue', dateValue.value)
}

function monthCall(value, preSelect = false) {
    if (props.disable) return;

    isActive.value = value;
    const date1 = startOfMonth(new Date());
    const date2 = endOfMonth(new Date());
    dateValue.value = [date1, date2];
    prevaldate.value = dateValue.value;
    if (preSelect) emit('update:modelValue', dateValue.value)
}

function onCLickOutSideOrCansal() {
    if (props.disable) {
        datePicker.value?.closeMenu();
        return;
    }

    if (props.range == true) {
        if (dateValue.value === null) {
            datePicker.value.closeMenu();
            return;
        }
        if (dateValue?.value[0] != prevaldate.value[0] || dateValue?.value[1] != prevaldate.value[1]) {
            dateValue.value = prevaldate.value;
            if (new Date(dateValue.value[0]).getTime() == startOfWeek(new Date()).getTime() && new Date(dateValue.value[1]).getTime() == endOfWeek(new Date()).getTime()) {
                isActive.value = 0;
            } else if (new Date(dateValue.value[0]).getTime() == startOfMonth(new Date()).getTime() && new Date(dateValue.value[1]).getTime() == endOfMonth(new Date()).getTime()) {
                isActive.value = 1;
            } else {
                isActive.value = 3;
            }
        }
        datePicker.value.closeMenu();
    } else {
        datePicker.value.closeMenu();
    }
    emit('outsideClick')
}

async function onSubmitVal() {
    if (props.disable) return;

    await datePicker.value.selectDate();
    if (new Date(dateValue?.value[0]).getTime() == startOfWeek(new Date()).getTime() && new Date(dateValue?.value[1]).getTime() == endOfWeek(new Date()).getTime()) {
        isActive.value = 0;
    } else if (new Date(dateValue?.value[0]).getTime() == startOfMonth(new Date()).getTime() && new Date(dateValue?.value[1]).getTime() == endOfMonth(new Date()).getTime()) {
        isActive.value = 1;
    } else {
        isActive.value = 3;
    }
    prevaldate.value = dateValue.value;
}

onMounted(() => {
    if (props.range == true) {
        nextTick(() => {
            if (props.preSelectable && !props.disable) {
                if (props.preSelectType === "month") {
                    monthCall(1, true);
                } else {
                    weekCall(0, true);
                }
            }
        })
        prevaldate.value = dateValue.value;

        document.addEventListener('mouseover', function (event) {
            if (event.target.classList.contains('dp__date_hover_end') || event.target.classList.contains('dp__date_hover_start')) {
                if (document.getElementsByClassName('isActive')[0] && document.getElementsByClassName('isActive')[0].classList) {
                    document.getElementsByClassName('isActive')[0].classList.remove('isActive');
                }
            }
        });
    }
})

function convertDateAndTime(timeformat, seconds, dateFormat) {
    try {
        if (!timeformat) {
            return `${convertDateFormat(seconds, dateFormat, { showDayName: false })} , ${moment(new Date(seconds)).format(`hh:mm A`)}`;
        } else {
            return `${convertDateFormat(seconds, dateFormat, { showDayName: false })} , ${moment(new Date(seconds)).format(`HH:mm`)}`;
        }
    } catch (error) {
        console.error("Error", error)
    }
}
</script>

<style scoped>
@import './style.css';

.calendar-disabled-wrapper {
    cursor: not-allowed;
}

.disabled-trigger {
    cursor: not-allowed !important;
    pointer-events: none;
}

.disabled-cursor {
    cursor: not-allowed !important;
}

.custom-date-input {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 8px;
    background-color: transparent;
    border-radius: 9999px;
    min-width: 140px;
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.custom-date-input:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.custom-date-input.disabled-trigger:hover {
    background-color: transparent !important;
}

.date-display {
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 1;
}

.calendar-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: #8e8e93;
}

.date-text {
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-weight: 400;
    color: #141414;
    line-height: 18px;
}

.nav-arrows {
    display: flex;
    align-items: center;
    gap: 0;
}

.nav-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 4px;
    background: transparent;
    border: none;
    border-radius: 2px;
    cursor: pointer;
    color: #8e8e93;
    transition: all 0.15s ease;
}

.nav-btn:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: #141414;
}

.nav-btn:disabled,
.dp-icon-btn:disabled,
.dp-today-btn:disabled {
    cursor: not-allowed !important;
    opacity: 0.5;
    pointer-events: none;
}

.dp-controller {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    font-family: Inter, sans-serif;
    font-size: 12px;
    color: #141414;
}

.dp-month-year {
    display: flex;
    align-items: center;
    gap: 4px;
}

.dp-month {
    display: flex;
    align-items: center;
    padding: 2px 0;
}

.dp-month-text {
    line-height: 18px;
    font-weight: 400;
    color: #141414;
}

.dp-rightsection {
    display: flex;
    align-items: center;
    gap: 0;
}

.dp-today-btn {
    display: flex;
    align-items: center;
    padding: 4px 8px;
    border-radius: 9999px;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: background-color 0.15s ease;
}

.dp-today-btn:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

.dp-today-label {
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: #8e8e93;
    letter-spacing: 0.1px;
    line-height: 16px;
}

.dp-btn-group {
    display: flex;
    align-items: center;
}

.dp-icon-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 4px;
    background: transparent;
    border: none;
    border-radius: 2px;
    cursor: pointer;
    color: #8e8e93;
    transition: all 0.15s ease;
}

.dp-icon-btn:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: #141414;
}

.dp-icon-btn svg {
    width: 16px;
    height: 16px;
}
</style>
